import { WorkloadConfig } from "../integrations/validator.ts";
import { getItemAnon } from "../../utils/localStorage.ts";

export const successNotificationTimeout = 8000;
export const infoNotificationTimeout = 8000;

const generateDummyWidgetButtons = () => {
  const noCredentialCtaTo = "/test-service/deploy";
  const noCredentialCtaBluexpTo = "storage/test-service/deploy";
  const noCredentialCtaLabel = "Manage workload";
  const primaryCtaDropdownLabel = "Deploy";

  const noCredentialCtaDropdownTo = [
    {
      to: noCredentialCtaTo,
      bluexpTo: noCredentialCtaBluexpTo,
      label: primaryCtaDropdownLabel,
      isDisabled: false,
    },
    {
      to: "/test-service/deploy2",
      bluexpTo: "storage/test-service/deploy2",
      label: "Deploy2",
      isDisabled: true,
      disabledTooltip: "This is disabled",
    },
  ];

  const hasWidgetWithDropDownCta = getItemAnon({
    itemKey: "feature.Platform.DummyWorkload/widgetWithDropDown",
  });

  if (hasWidgetWithDropDownCta) {
    return {
      noCredentialCtaDropdownTo,
      noCredentialCtaLabel
    };
  } else{
    return {
      noCredentialCtaTo,
      noCredentialCtaBluexpTo,
      noCredentialCtaLabel
    };
  }
}

const generateDummyButtons = () => {
  const primaryCtaTo = "/test-service/deploy";
  const primaryCtaBluexpTo = "storage/test-service/deploy";
  const primaryCtaLabel = "Create the best service ever";
  const secondaryCtaLabel = "Manage workload";
  const primaryCtaDropdownLabel = "Deploy";
  const mainPrimaryCtaDropdownLabel = "Deploy main";

  const primaryDropdown = [
    {
      to: primaryCtaTo,
      bluexpTo: primaryCtaBluexpTo,
      label: primaryCtaDropdownLabel,
      isDisabled: false,
    },
    {
      to: "/test-service/deploy2",
      bluexpTo: "storage/test-service/deploy2",
      label: "Deploy2",
      isDisabled: true,
      disabledTooltip: "This is disabled",
    },
  ];

  const mainPrimaryDropdown = [
    {
      to: "/test-service/deploy-main",
      bluexpTo: "storage/test-service/deploy-main",
      label: "Deploy-main",
      isDisabled: false,
    },
    {
      to: "/test-service/deploy-main-2",
      bluexpTo: "storage/test-service/deploy-main-22",
      label: "Deploy-main-2",
      isDisabled: true,
      disabledTooltip: "This is disabled",
    },
  ];

  const hasPrimaryAndDropdownCta = getItemAnon({
    itemKey: "feature.Platform.DummyWorkload/primaryAndDropdownCta",
  });
  const hasPrimaryMainAndDropdownCta = getItemAnon({
    itemKey: "feature.Platform.DummyWorkload/mainPrimaryDropdownAndDropdownCta",
  });
  const hasDropdownCta = getItemAnon({
    itemKey: "feature.Platform.DummyWorkload/dropdownCta",
  });

  if (hasPrimaryMainAndDropdownCta) {
    return {
      secondaryCtaLabel,
      primaryCtaDropdownLabel,
      primaryCtaDropdownTo: primaryDropdown,
      mainPrimaryCtaDropdownLabel,
      mainPrimaryCtaDropdownTo: mainPrimaryDropdown,
    };
  } else if (hasPrimaryAndDropdownCta) {
    return {
      primaryCtaTo,
      primaryCtaBluexpTo,
      primaryCtaLabel,
      secondaryCtaLabel,
      primaryCtaDropdownLabel,
      primaryCtaDropdownTo: primaryDropdown,
    };
  } else if (hasDropdownCta) {
    return {
      primaryCtaDropdownLabel,
      primaryCtaDropdownTo: primaryDropdown,
    };
  } else {
    return {
      primaryCtaTo,
      primaryCtaBluexpTo,
      primaryCtaLabel,
    };
  }
};

export const localWorkloadsConfig: (WorkloadConfig | any)[] = [
  {
    name: "Overview",
    to: "/",
    id: "overview",
    serviceNav: {
      label: "Workloads overview",
      description: "Automate provisioning, governance, and lifecycle for FSx for ONTAP. Explore cost savings and advanced management."
    }
  },
    {
    name: "Test Service",
    to: "/test-service",
    id: "test-service",
    features: [
      {
        title: "Dummy Workload",
        id: "Platform.DummyWorkload/*",
        isAnon: true,
      },
      {
        title: "Dummy Workload - is active",
        id: "Platform.DummyWorkload/active",
        isAnon: true,
      },
      {
        title: "Dummy Workload - dropdown CTA",
        id: "Platform.DummyWorkload/dropdownCta",
        isAnon: true,
      },
      {
        title: "Dummy Workload - primary CTA + dropdown CTA",
        id: "Platform.DummyWorkload/primaryAndDropdownCta",
        isAnon: true,
      },
      {
        title: "Dummy Workload - main primary dropdown + secondary dropdown CTA",
        id: "Platform.DummyWorkload/mainPrimaryDropdownAndDropdownCta",
        isAnon: true,
      },
      {
        title: "Dummy Workload - new home page",
        id: "Platform.DummyWorkload/newHomePage",
        isAnon: true,
      },
      {
        title: "Dummy Workload - new home page - widget with drop down",
        id: "Platform.DummyWorkload/widgetWithDropDown",
        isAnon: true,
      },
    ],
    stageIntegrations: [
      {
        path: "/",
        renderType: "iframe/v2",
        iframeUrl: "/test-service.html",
      },
    ],
    homepage: {
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type.",
      secondaryCtaLabel: "Manage workload",
      ...generateDummyButtons(),
      secondaryCtaTo: "/test-service/manage",
      secondaryCtaBluexpTo: "storage/test-service/manage",
      isComingSoon: false,
      dataUrl: `/dummy-workload/v1/is-active${
        getItemAnon({ itemKey: `feature.Platform.DummyWorkload/active` }) ? "?activity=true" : "?activity=false"
      }`,
      featureId: "Platform.DummyWorkload/*",
      marketingUrl: "test-service/marketing",
      marketingBlueXPUrl: "test-service/blueXp/marketing",
    },
      serviceNav: {
        label: "Test Service",
        featureId: "Platform.DummyWorkload/*",
        description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type.",
        tabs: [{
          label: "Dashboard",
          to: "/test-service/dashboard",
        },{
          label: "Inventory",
          to: "/test-service/inventory",
        }
      ]
    },
    logo:
      '<svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
      '<rect width="80" height="80" rx="4" fill="#E8EEFD"/>\n' +
      '<g filter="url(#filter0_d_6417_386)">\n' +
      '<path d="M62.5535 21.0045C62.6006 20.6765 62.625 20.3411 62.625 20C62.625 16.134 59.491 13 55.625 13C52.9383 13 50.6051 14.5136 49.4317 16.7347C48.7929 16.0518 47.8838 15.625 46.875 15.625C44.942 15.625 43.375 17.192 43.375 19.125V19.1976C40.892 19.6142 39 21.7736 39 24.375C39 25.3313 39.2557 26.2278 39.7024 27H65.8151C66.5417 26.3587 67 25.4204 67 24.375C67 22.442 65.433 20.875 63.5 20.875C63.172 20.875 62.8545 20.9201 62.5535 21.0045Z" fill="white"/>\n' +
      "</g>\n" +
      '<g filter="url(#filter1_d_6417_386)">\n' +
      '<path d="M29.4591 20.574C29.4861 20.3865 29.5 20.1949 29.5 20C29.5 17.7909 27.7091 16 25.5 16C23.9647 16 22.6315 16.8649 21.9609 18.1341C21.596 17.7439 21.0765 17.5 20.5 17.5C19.3954 17.5 18.5 18.3954 18.5 19.5V19.5415C17.0811 19.7795 16 21.0135 16 22.5C16 23.0464 16.1461 23.5587 16.4013 24H31.3229C31.7381 23.6335 32 23.0973 32 22.5C32 21.3954 31.1046 20.5 30 20.5C29.8126 20.5 29.6312 20.5258 29.4591 20.574Z" fill="white"/>\n' +
      "</g>\n" +
      '<path d="M56.3774 29.722C56.4582 29.1596 56.5 28.5847 56.5 28C56.5 21.3726 51.1274 16 44.5 16C39.8942 16 35.8944 18.5948 33.8828 22.4023C32.7879 21.2317 31.2294 20.5 29.5 20.5C26.1863 20.5 23.5 23.1863 23.5 26.5V26.6244C19.2434 27.3386 16 31.0405 16 35.5C16 37.1393 16.4383 38.6762 17.204 40H61.9687C63.2144 38.9006 64 37.292 64 35.5C64 32.1863 61.3137 29.5 58 29.5C57.4377 29.5 56.8935 29.5774 56.3774 29.722Z" fill="url(#paint0_linear_6417_386)"/>\n' +
      '<path fill-rule="evenodd" clip-rule="evenodd" d="M43.874 47C43.5122 45.5944 42.4056 44.4878 41 44.126V42H39V44.126C37.5944 44.4878 36.4878 45.5944 36.126 47H22C21.4477 47 21 47.4477 21 48V52H23V49H36.126C36.5701 50.7252 38.1362 52 40 52C41.8638 52 43.4299 50.7252 43.874 49H57V52H59V48C59 47.4477 58.5523 47 58 47H43.874Z" fill="url(#paint1_linear_6417_386)"/>\n' +
      '<path d="M22 60.8632C19.1811 60.8632 16.8479 60.2325 16 59.3333V62.0125C16 63.0896 18.7476 64 22 64C25.2524 64 28 63.0898 28 62.0125V59.3333C27.1524 60.2325 24.8187 60.8632 22 60.8632Z" fill="url(#paint2_linear_6417_386)"/>\n' +
      '<path d="M28 63.3333C27.1524 64.2325 24.8187 64.863 22 64.863C19.1813 64.863 16.8479 64.2325 16 63.3333V66.0124C16 67.0898 18.7476 68 22 68C25.2524 68 28 67.0898 28 66.0124V63.3333Z" fill="url(#paint3_linear_6417_386)"/>\n' +
      '<path d="M22 52C18.7477 52 16 52.9159 16 53.9999C16 55.084 18.7476 56 22 56C25.2524 56 28 55.0841 28 53.9999C28 52.9158 25.2524 52 22 52Z" fill="url(#paint4_linear_6417_386)"/>\n' +
      '<path d="M22 56.8631C19.1811 56.8631 16.8479 56.2325 16 55.3333V58.0124C16 59.0898 18.7476 60 22 60C25.2524 60 28 59.0898 28 58.0124V55.3333C27.1524 56.2325 24.8187 56.8631 22 56.8631Z" fill="url(#paint5_linear_6417_386)"/>\n' +
      '<path d="M58 60.8632C55.1811 60.8632 52.8479 60.2325 52 59.3333V62.0125C52 63.0896 54.7476 64 58 64C61.2524 64 64 63.0898 64 62.0125V59.3333C63.1524 60.2325 60.8187 60.8632 58 60.8632Z" fill="url(#paint6_linear_6417_386)"/>\n' +
      '<path d="M64 63.3333C63.1524 64.2325 60.8187 64.863 58 64.863C55.1813 64.863 52.8479 64.2325 52 63.3333V66.0124C52 67.0898 54.7476 68 58 68C61.2524 68 64 67.0898 64 66.0124V63.3333Z" fill="url(#paint7_linear_6417_386)"/>\n' +
      '<path d="M58 52C54.7477 52 52 52.9159 52 53.9999C52 55.084 54.7476 56 58 56C61.2524 56 64 55.0841 64 53.9999C64 52.9158 61.2524 52 58 52Z" fill="url(#paint8_linear_6417_386)"/>\n' +
      '<path d="M58 56.8631C55.1811 56.8631 52.8479 56.2325 52 55.3333V58.0124C52 59.0898 54.7476 60 58 60C61.2524 60 64 59.0898 64 58.0124V55.3333C63.1524 56.2325 60.8187 56.8631 58 56.8631Z" fill="url(#paint9_linear_6417_386)"/>\n' +
      "<defs>\n" +
      '<filter id="filter0_d_6417_386" x="35" y="9" width="40" height="26" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">\n' +
      '<feFlood flood-opacity="0" result="BackgroundImageFix"/>\n' +
      '<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>\n' +
      '<feOffset dx="2" dy="2"/>\n' +
      '<feGaussianBlur stdDeviation="3"/>\n' +
      '<feComposite in2="hardAlpha" operator="out"/>\n' +
      '<feColorMatrix type="matrix" values="0 0 0 0 0.878431 0 0 0 0 0.878431 0 0 0 0 0.878431 0 0 0 1 0"/>\n' +
      '<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_6417_386"/>\n' +
      '<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_6417_386" result="shape"/>\n' +
      "</filter>\n" +
      '<filter id="filter1_d_6417_386" x="12" y="12" width="28" height="20" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">\n' +
      '<feFlood flood-opacity="0" result="BackgroundImageFix"/>\n' +
      '<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>\n' +
      '<feOffset dx="2" dy="2"/>\n' +
      '<feGaussianBlur stdDeviation="3"/>\n' +
      '<feComposite in2="hardAlpha" operator="out"/>\n' +
      '<feColorMatrix type="matrix" values="0 0 0 0 0.878431 0 0 0 0 0.878431 0 0 0 0 0.878431 0 0 0 1 0"/>\n' +
      '<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_6417_386"/>\n' +
      '<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_6417_386" result="shape"/>\n' +
      "</filter>\n" +
      '<linearGradient id="paint0_linear_6417_386" x1="40" y1="16" x2="40" y2="58.6667" gradientUnits="userSpaceOnUse">\n' +
      '<stop stop-color="#0BAFFC"/>\n' +
      '<stop offset="1" stop-color="#0BAFFC" stop-opacity="0"/>\n' +
      "</linearGradient>\n" +
      '<linearGradient id="paint1_linear_6417_386" x1="40" y1="42" x2="40" y2="59.7778" gradientUnits="userSpaceOnUse">\n' +
      '<stop stop-color="#0BAFFC"/>\n' +
      '<stop offset="1" stop-color="#0BAFFC" stop-opacity="0"/>\n' +
      "</linearGradient>\n" +
      '<linearGradient id="paint2_linear_6417_386" x1="22" y1="52" x2="22" y2="78.9474" gradientUnits="userSpaceOnUse">\n' +
      '<stop stop-color="#A815F3"/>\n' +
      '<stop offset="1" stop-color="#A815F3" stop-opacity="0"/>\n' +
      "</linearGradient>\n" +
      '<linearGradient id="paint3_linear_6417_386" x1="22" y1="52" x2="22" y2="78.9474" gradientUnits="userSpaceOnUse">\n' +
      '<stop stop-color="#A815F3"/>\n' +
      '<stop offset="1" stop-color="#A815F3" stop-opacity="0"/>\n' +
      "</linearGradient>\n" +
      '<linearGradient id="paint4_linear_6417_386" x1="22" y1="52" x2="22" y2="78.9474" gradientUnits="userSpaceOnUse">\n' +
      '<stop stop-color="#A815F3"/>\n' +
      '<stop offset="1" stop-color="#A815F3" stop-opacity="0"/>\n' +
      "</linearGradient>\n" +
      '<linearGradient id="paint5_linear_6417_386" x1="22" y1="52" x2="22" y2="78.9474" gradientUnits="userSpaceOnUse">\n' +
      '<stop stop-color="#A815F3"/>\n' +
      '<stop offset="1" stop-color="#A815F3" stop-opacity="0"/>\n' +
      "</linearGradient>\n" +
      '<linearGradient id="paint6_linear_6417_386" x1="58" y1="52" x2="58" y2="78.9474" gradientUnits="userSpaceOnUse">\n' +
      '<stop stop-color="#A815F3"/>\n' +
      '<stop offset="1" stop-color="#A815F3" stop-opacity="0"/>\n' +
      "</linearGradient>\n" +
      '<linearGradient id="paint7_linear_6417_386" x1="58" y1="52" x2="58" y2="78.9474" gradientUnits="userSpaceOnUse">\n' +
      '<stop stop-color="#A815F3"/>\n' +
      '<stop offset="1" stop-color="#A815F3" stop-opacity="0"/>\n' +
      "</linearGradient>\n" +
      '<linearGradient id="paint8_linear_6417_386" x1="58" y1="52" x2="58" y2="78.9474" gradientUnits="userSpaceOnUse">\n' +
      '<stop stop-color="#A815F3"/>\n' +
      '<stop offset="1" stop-color="#A815F3" stop-opacity="0"/>\n' +
      "</linearGradient>\n" +
      '<linearGradient id="paint9_linear_6417_386" x1="58" y1="52" x2="58" y2="78.9474" gradientUnits="userSpaceOnUse">\n' +
      '<stop stop-color="#A815F3"/>\n' +
      '<stop offset="1" stop-color="#A815F3" stop-opacity="0"/>\n' +
      "</linearGradient>\n" +
      "</defs>\n" +
      "</svg>\n",
      focus:[{
        id: "first-focus-item",
        suffixPlural: "instances",
        suffixSingular: "instance",
        dataUrl: "/dummy-workload/v1/homepage-focus",
        primaryCtaTo: "/test-service/deploy",
        primaryCtaBluexpTo: "/storage/test-service/deploy",
        primaryCtaLabel: "Create instance",
        featureId: "Platform.DummyWorkload/newHomePage",
      }],
      widget: {
        title: "Manage your Test Service instances",
        primaryCtaTo: "/test-service/manage",
        primaryCtaBluexpTo: "storage/test-service/manage",
        primaryCtaLabel: "Go to inventory",
        dataUrl: "/dummy-workload/v1/homepage-widget",
        marketingUrl: "test-service/widget-marketing",
        marketingBlueXPUrl: "test-service/widget-blueXp-marketing",
        featureId: "Platform.DummyWorkload/newHomePage",
        ...generateDummyWidgetButtons(),
        metricWidgets: [
          {
            id: "savings-opportunities",
            type: "metric",
            label: "Savings opportunities",
          }
        ],
        icon:
            `<svg aria-hidden="true" width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">

<path d="M38.2057 29.1192L38.1379 28.2774C38.4059 28.264 38.6579 28.1456 38.8393 27.9478C39.0208 27.75 39.117 27.4888 39.1073 27.2206C39.1122 26.9531 39.0144 26.6939 38.8341 26.4963C38.6538 26.2987 38.4047 26.1776 38.1379 26.158C38.0291 26.1391 37.932 26.0783 37.8675 25.9886C37.803 25.899 37.7762 25.7876 37.7929 25.6784C37.7923 25.5531 37.7552 25.4307 37.6861 25.3262C37.6171 25.2216 37.5191 25.1394 37.4042 25.0896C37.3209 25.0673 37.2328 25.0715 37.152 25.1016C37.0712 25.1317 37.0018 25.1862 36.9534 25.2575C36.9071 25.3192 36.8452 25.3673 36.774 25.3969C36.7028 25.4264 36.6249 25.4363 36.5486 25.4254C36.4728 25.4141 36.4016 25.3824 36.3426 25.3335C36.2836 25.2847 36.2391 25.2206 36.2139 25.1483C36.1163 24.8574 35.9553 24.5919 35.7424 24.3709C35.5094 24.1238 35.2053 23.9555 34.8723 23.8891C34.5393 23.8227 34.1939 23.8617 33.884 24.0006C33.6029 24.1426 33.3652 24.3576 33.1956 24.623C33.0261 24.8885 32.931 25.1946 32.9203 25.5094C32.9151 25.5783 32.9151 25.6475 32.9203 25.7164C32.9333 25.8148 32.9114 25.9147 32.8585 25.9987C32.8056 26.0827 32.7249 26.1455 32.6305 26.1764C32.3924 26.2194 32.1786 26.3488 32.03 26.5398C31.8815 26.7309 31.8086 26.97 31.8255 27.2114C31.8229 27.2569 31.8229 27.3026 31.8255 27.3482C31.8602 27.6043 31.987 27.8389 32.1821 28.0082C32.3773 28.1776 32.6275 28.27 32.8858 28.2682V29.1135C32.6332 29.1179 32.3823 29.0718 32.1479 28.9777C31.9134 28.8836 31.7002 28.7435 31.5208 28.5657C31.3413 28.3879 31.1993 28.1759 31.1032 27.9423C31.007 27.7087 30.9585 27.4582 30.9607 27.2056C30.9472 26.8384 31.0455 26.4757 31.2426 26.1656C31.4398 25.8555 31.7264 25.6126 32.0647 25.4691C32.0813 24.994 32.2283 24.5327 32.4895 24.1355C32.7508 23.7384 33.1162 23.4207 33.5459 23.2174C34.0118 23.0093 34.5308 22.9511 35.0313 23.0508C35.5317 23.1505 35.9887 23.4032 36.3393 23.774C36.5099 23.9412 36.6566 24.1313 36.7751 24.3387C37.0467 24.2115 37.3553 24.1874 37.6434 24.2708C37.8899 24.3513 38.1092 24.499 38.2764 24.6973C38.4436 24.8956 38.5521 25.1366 38.5898 25.3932C38.9884 25.4988 39.3397 25.7359 39.5866 26.0662C39.8335 26.3964 39.9617 26.8003 39.9503 27.2125C39.9634 27.6946 39.7889 28.163 39.4634 28.5189C39.138 28.8748 38.6871 29.0904 38.2057 29.1204V29.1192ZM7.75029 29.7724H8.81519V23.9569H13.8614V23.0001H8.82554V18.2161H14.786V17.2604H7.75029V29.7724ZM22.9027 24.6572C23.3109 25.1786 23.5219 25.8274 23.4984 26.4892C23.5116 26.9828 23.4118 27.4729 23.2065 27.9219C23.0012 28.371 22.6958 28.7672 22.3139 29.0801C21.4308 29.7714 20.3292 30.1235 19.2089 30.0726C17.9751 30.0967 16.752 29.8395 15.6324 29.3205V28.4005C16.7451 28.8294 17.9235 29.0629 19.1157 29.0905C19.97 29.1345 20.8138 28.8858 21.5077 28.3855C21.7985 28.1612 22.0314 27.8706 22.1869 27.5378C22.3423 27.2051 22.4158 26.84 22.4013 26.4731C22.41 26.0039 22.235 25.55 21.9137 25.2081C21.4645 24.7847 20.9284 24.4645 20.3428 24.2697L18.2463 23.4474C17.4728 23.1848 16.7735 22.7403 16.2074 22.1514C15.7696 21.6362 15.5389 20.9767 15.5599 20.301C15.5451 19.8421 15.6338 19.3858 15.8196 18.9659C16.0053 18.546 16.2833 18.1733 16.6329 17.8757C17.4275 17.228 18.4333 16.8967 19.4573 16.9453C20.0187 16.9487 20.5781 17.0123 21.1259 17.1351C21.695 17.2576 22.2499 17.4383 22.7819 17.6744V18.5944C21.7377 18.1963 20.6341 17.9763 19.5171 17.9435C18.7587 17.8928 18.0062 18.1061 17.3873 18.5473C17.1389 18.758 16.9427 19.0234 16.8142 19.3227C16.6857 19.622 16.6284 19.9471 16.6467 20.2723C16.6324 20.627 16.7117 20.9792 16.8767 21.2935C17.0579 21.5846 17.3079 21.8266 17.6046 21.9984C18.0722 22.2695 18.5643 22.4959 19.0743 22.6746L21.0075 23.4152C21.7345 23.6585 22.387 24.0842 22.9027 24.6515V24.6572ZM27.3083 23.6487L24.4253 19.58H25.9318L28.0673 22.6252L27.3083 23.6487ZM29.3783 24.4261L30.5283 26.0591C30.3095 26.5203 30.1451 27.0054 30.0384 27.5046L27.9684 24.5146L28.7021 23.4992L31.4437 19.5892H32.8766L29.3783 24.4261ZM27.3083 25.3794L27.9638 26.2994L25.5488 29.8391H24.0975L27.3083 25.3794ZM36.6038 31.0294C36.6918 31.0042 36.7692 30.9511 36.8243 30.8781C36.8795 30.805 36.9095 30.7161 36.9097 30.6246V27.0124C36.9097 26.9003 36.8652 26.7928 36.7859 26.7136C36.7066 26.6343 36.5991 26.5898 36.4871 26.5898C36.375 26.5898 36.2675 26.6343 36.1882 26.7136C36.109 26.7928 36.0644 26.9003 36.0644 27.0124V29.1399L34.5982 26.7916C34.5475 26.717 34.4744 26.6604 34.3894 26.63C34.3044 26.5996 34.212 26.597 34.1255 26.6227C34.0389 26.6483 33.9628 26.7007 33.908 26.7724C33.8533 26.8441 33.8227 26.9314 33.8208 27.0216V30.6188C33.8303 30.7246 33.8791 30.823 33.9575 30.8946C34.0359 30.9663 34.1383 31.006 34.2446 31.006C34.3508 31.006 34.4532 30.9663 34.5316 30.8946C34.61 30.823 34.6588 30.7246 34.6683 30.6188V28.4902L36.1346 30.8385C36.1721 30.8996 36.2247 30.9501 36.2873 30.9851C36.3499 31.0202 36.4205 31.0386 36.4922 31.0386C36.5344 31.0396 36.5764 31.0334 36.6164 31.0202L36.6038 31.0294Z" fill="var(--icon-primary)"/>
    <circle class="bluexp-service-icon-circle" fill-rule="evenodd" clip-rule="evenodd" cx="24" cy="24" r="23" stroke-width="2" stroke="var(--icon-primary)"/>

</svg>
`
      }
  },
  {
    name: "Credentials dummy workload",
    to: "/credentials-service",
    id: "credentials-test-workload",
    features: [
      {
        title: "Dummy workload ",
        id: "Credentials.DummyWorkload/active",
        isAnon: true,
      },
      {
        title: "Dummy Workload - read inactive",
        id: "Credentials.DummyWorkload/read-inactive",
        isAnon: true,
      },
      {
        title: "Dummy Workload - automate inactive",
        id: "Credentials.DummyWorkload/automate-inactive",
        isAnon: true,
      },
    ],
  },
];
